import { CommonModule } from "@angular/common";
import { AfterViewInit, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Router, RouterLink } from "@angular/router";
import { PageState } from "@core/models/common.interface";
import { PageService } from "@core/services/page.service";

@Component({
  selector: "app-app-bar",
  standalone: true,
  templateUrl: "./app-bar.component.html",
  styleUrl: "./app-bar.component.scss",
  imports: [
    MatCardModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    CommonModule,
    MatCheckboxModule,
  ],
})
export class AppBarComponent implements AfterViewInit {
  pageState = PageState;

  constructor(private router: Router, private pageService: PageService) {}

  back() {
    this.router.navigate(["/landing"]);
  }

  login() {
    this.router.navigate(["/auth/login"]);
  }

  join() {
    this.router.navigate(["/auth/register"]);
  }

  ngAfterViewInit(): void {
    this.getPageState();
  }

  getPageState(): PageState {
    return this.pageService.getPageState();
  }
}
